module.exports = __webpack_public_path__ + "img/617.toaster.cf6c884a.svg";